// extracted by mini-css-extract-plugin
export default {"table_wrap":"deliveryDetails_table_wrap__lx4Bh"};